import BuyerAssurance from '../src/BuyerAssurance';
export default BuyerAssurance;
